import { createContext } from "react";
import { TalentsContextInterface } from "../interfaces/ReferenciaEncontrarTalento";

const initialValuesFilters = {
    region: {
        items: [],
    },
    city: {
        items: [],
    },
    educationLevel: {
        values: [],
        items: [],
    },
    profession: {
        values: [],
        items: [],
    },
    area: {
        values: [],
        items: [],
    },
    populationGroup: {
        values: [],
        items: [],
    },
    language: {
        items: [],
    },
    languageLevel: {
        items: [],
    },
    keyWord: {
        items: [],
    }
};

const Context: TalentsContextInterface = {
    loading: false,
    keyWord: "",
    queryParameters: "",
    talents: [],
    filterCatalogData: {},
    selectedFilters: initialValuesFilters,
    initialSelectedFilters: initialValuesFilters,
    currentPage: 0,
    currentTotal: 0,
    setCurrentPage: () => {},
    setKeyWord: () => {},
    setQueryParameters: () => {},
    setSelectedFilters: () => {},
    onSubmitSearchHandler: () => {}
};

const TalentsContext = createContext<TalentsContextInterface>(Context);

export default TalentsContext;